import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import {
  ArrowForward,
  ShoppingCartOutlined,
  Home,
  Logout,
  Person,
  Login,
  KeyboardArrowDownSharp,
  ChevronRight,
  LibraryBooks,
  LocalLibraryRounded,
  Close,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { Badge, Typography } from "@mui/material";
import logo from "../assets/logo.png";
import logo3 from "../assets/icon.png";
import { NavLink } from "react-router-dom";
import { basePath } from "../utility";
import Search from "../components/Search";
import { login, logout } from "../redux/logger/logActions";

//import SearchBox from "../components/SearchBox";

const Navbar = ({
  toggleSideBar,
  handleToggle,
  openLoginDialog,
  setOpenLoginDialog,
  logType,
  setLogType,

  setCurrentTab,
}) => {
  const [userName, setUserName] = useState("");
  const [toggleDropDownAccount, setToggleDropDownAccount] = useState(false);
  const [toggleDropDownSearch, setToggleDropDownSearch] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const navData = location.state;

  const logger = useSelector((state) => {
    return state.logger;
  });

  const handleToggleDropDownSearch = () => {
    setToggleDropDownSearch((val) => {
      return !val;
    });
  };

  const dispatch = useDispatch();
  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      // right: -3,
      // top: 13,
      // border: `2px solid ${theme.palette.background.paper}`,
      padding: "0 4px",
      fontWeight: "bold",
      backgroundColor: "#4583fc",
      color: "#fff",
    },
  }));

  const handleLogout = () => {
    try {
      axios.get(`${basePath.url}auth/logout`).then((response) => {
        dispatch(logout());
        navigate("/");
      });
    } catch (error) {
      alert(error.message);
    }
  };

  const toggleAccountDropdown = () => {
    setToggleDropDownAccount((val) => {
      return !val;
    });
  };

  useEffect(() => {
    if (logger && logger.user.name) {
      let nameArr = logger.user.name.split(" ");
      setUserName(nameArr[0]);
    }
  }, [logger]);
  return (
    <>
      <nav
        style={{
          // backgroundColor: "#011846"
          backgroundColor: "#07330b",
          padding: 0,
        }}
      >
        <ul className="menu" style={{ position: "relative" }}>
          <li className="menu-logo">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 3,
              }}
            >
              <img src={logo3} height={"35px"} width={55} />
              <Typography
                variant="subtitle1"
                style={{ fontSize: 16, color: "#fff" }}
              >
                The East African University
              </Typography>
            </div>
          </li>

          <li className="searchMenu" style={{ boxSizing: "border-box" }}></li>

          <div className="topMenu" style={{ position: "relative" }}>
            <li className="nav-menu-item ">
              <Home
                style={{ fontSize: 25, marginLeft: 20, color: "#fff" }}
                onClick={() => {
                  navigate("/");
                }}
              />
            </li>

            <li
              className="nav-menu-item-right"
              // style={{
              //   display: "flex",
              //   flexDirection: "row",
              //   justifyContent: "space-between",
              //   gap: 15,
              // }}
            >
              {logger.isLogged === true ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      cursor: "pointer",
                      marginLeft: 20,
                      gap: 10,
                    }}
                    onClick={() => {
                      // navigate("/user-profile");
                      setToggleDropDownAccount((val) => {
                        return !val;
                      });
                    }}
                    onMouseEnter={() => {
                      setToggleDropDownAccount(true);
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {!logger.user.avatar ? (
                        <Person
                          style={{
                            width: 40,
                            border: "1px solid #ccc",
                            fontSize: 40,
                            borderRadius: "50%",
                            padding: 5,
                            color: "#ccc",
                          }}
                        />
                      ) : null}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{ color: "#fff", fontWeight: 500, fontSize: 12 }}
                      >
                        Hi, {userName}
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          gap: 3,
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          style={{
                            color: "#fff",
                            fontWeight: 600,
                            fontSize: 12,
                          }}
                        >
                          Account
                        </Typography>
                        <KeyboardArrowDownSharp
                          style={{ color: "#fff", fontSize: 16 }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      cursor: "pointer",
                      gap: 5,
                      marginRight: 20,
                    }}
                    onClick={() => {
                      handleLogout();
                    }}
                  >
                    <Logout
                      style={{ fontSize: 20, marginLeft: 20, color: "#fff" }}
                    />
                    <Typography
                      variant="subtitle2"
                      style={{ color: "#fff", fontWeight: 600 }}
                    >
                      Logout
                    </Typography>
                  </div>
                </>
              ) : (
                <a
                  onClick={() => {
                    setLogType("login");
                    setOpenLoginDialog((prev) => {
                      return !prev;
                    });
                  }}
                >
                  {" "}
                  <Typography
                    variant="subtitle2"
                    style={{ color: "#fff", fontWeight: 600 }}
                  >
                    Log in
                  </Typography>
                </a>
              )}
            </li>
            {logger.isLogged === true ? null : (
              <li className="menu-item ">
                <a
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 10,
                  }}
                  onClick={() => {
                    setLogType("signup");
                    setOpenLoginDialog((prev) => {
                      return !prev;
                    });
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    style={{ color: "#fff", fontWeight: 600 }}
                  >
                    Sign Up
                  </Typography>{" "}
                  <ArrowForward style={{ color: "white" }} />
                </a>
              </li>
            )}
            <div
              style={{
                position: "absolute",
                marginLeft: 0,
                left: 0,
                right: 0,

                top: 48,
                backgroundColor: "#07330b",
                borderRadius: 5,
                borderTopRightRadius: 0,
                borderTopLeftRadius: 0,
                opacity: 0.8,
                display: toggleDropDownAccount ? "block" : "none",
                padding: 20,
                color: "#fff",
              }}
              // onMouseEnter={() => {
              //   setToggleDropDownAccount(true);
              // }}
              // onMouseLeave={toggleAccountDropdown}
              onMouseLeave={() => {
                setToggleDropDownAccount(false);
              }}
            >
              <div
                style={{
                  width: "100%",

                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <div style={{ width: "100%" }}>
                  {logger.isLogged === true ? (
                    <>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          cursor: "pointer",
                          marginLeft: 0,
                          width: "100%",
                          // backgroundColor: "yellow",
                        }}
                        onClick={() => {
                          navigate("/user-profile");
                          setToggleDropDownAccount((val) => {
                            return !val;
                          });
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            alignItems: "center",
                            gap: 15,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {!logger.user.avatar ? (
                              <Person
                                style={{
                                  width: 50,
                                  border: "1px solid #ccc",
                                  fontSize: 50,
                                  borderRadius: "50%",
                                  padding: 5,
                                  color: "#ccc",
                                }}
                              />
                            ) : null}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                              alignItems: "flex-start",
                            }}
                          >
                            <Typography
                              variant="subtitle2"
                              style={{
                                color: "#fff",
                                fontWeight: 500,
                                fontSize: 14,
                                textAlign: "left",
                              }}
                            >
                              Welcome
                            </Typography>
                            <Typography
                              variant="subtitle2"
                              style={{
                                color: "#fff",
                                fontWeight: 500,
                                fontSize: 16,
                              }}
                            >
                              {logger.user.name}
                            </Typography>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 5,
                            margin: 10,
                            marginTop: 50,
                            width: "100%",
                            border: 0,
                            padding: 5,
                            borderRadius: 8,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              gap: 5,
                            }}
                            onClick={() => setCurrentTab("My Applications")}
                          >
                            <LibraryBooks
                              style={{ color: "#fff", fontSize: 25 }}
                            />
                            <Typography
                              variant="subtitle2"
                              style={{ color: "#fff", fontWeight: 500 }}
                            >
                              My Applications
                            </Typography>
                          </div>

                          <ChevronRight
                            style={{ color: "#fff", fontSize: 25 }}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <a
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 10,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setLogType("signup");
                          setOpenLoginDialog((prev) => {
                            return !prev;
                            // setToggleDropDownAccount((val) => {
                            //   return !val;
                            // });
                          });
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          style={{ color: "#fff", fontWeight: 600 }}
                        >
                          Sign Up
                        </Typography>{" "}
                        <ArrowForward style={{ color: "white" }} />
                      </a>
                      <a
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: 10,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setLogType("login");
                          setOpenLoginDialog((prev) => {
                            return !prev;
                          });
                          setToggleDropDownAccount((val) => {
                            return !val;
                          });
                        }}
                      >
                        <Login style={{ color: "#fff" }} />
                        <Typography
                          variant="subtitle2"
                          style={{ color: "#fff", fontWeight: 600 }}
                        >
                          Log in
                        </Typography>
                      </a>
                    </div>
                  )}
                </div>
                <div
                  style={{
                    width: "100%",

                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderTop: "1px solid #ccc",
                    marginTop: 50,
                    paddingTop: 10,
                  }}
                >
                  {logger.isLogged ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        cursor: "pointer",
                        gap: 5,
                      }}
                      onClick={() => {
                        handleLogout();
                        setToggleDropDownAccount((val) => {
                          return !val;
                        });
                      }}
                    >
                      <Logout
                        style={{ fontSize: 20, marginLeft: 20, color: "#fff" }}
                      />
                      <Typography
                        variant="subtitle2"
                        style={{ color: "#fff", fontWeight: 600 }}
                      >
                        Logout
                      </Typography>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  <div>
                    {/* <Typography
                      variant="subtitle2"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setToggleDropDownAccount((val) => {
                          return !val;
                        });
                      }}
                    >
                      close
                    </Typography> */}
                    <Close
                      style={{ fontSize: 20, cursor: "pointer" }}
                      onClick={() => {
                        setToggleDropDownAccount((val) => {
                          return !val;
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <li className="toggle">
            <span
              style={{ fontSize: "25px", paddingRight: 15 }}
              onClick={handleToggle}
            >
              &#9776;
            </span>
          </li>
          <div
            style={{
              position: "absolute",
              marginLeft: 0,
              left: 0,
              right: 0,
              // height: 150,
              top: 48,
              backgroundColor: "#07330b",
              borderRadius: 5,
              borderTopRightRadius: 0,
              borderTopLeftRadius: 0,
              opacity: 0.8,
              display: toggleSideBar ? "block" : "none",
              padding: 20,
              color: "#fff",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              <div style={{ width: "100%" }}>
                {logger.isLogged === true ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        cursor: "pointer",
                        marginLeft: 0,
                        width: "100%",
                        // backgroundColor: "yellow",
                      }}
                      onClick={() => {
                        navigate("/user-profile");
                        handleToggle();
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          gap: 15,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {!logger.user.avatar ? (
                            <Person
                              style={{
                                width: 50,
                                border: "1px solid #ccc",
                                fontSize: 50,
                                borderRadius: "50%",
                                padding: 5,
                                color: "#ccc",
                              }}
                            />
                          ) : null}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            style={{
                              color: "#fff",
                              fontWeight: 500,
                              fontSize: 14,
                              textAlign: "left",
                            }}
                          >
                            Welcome
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            style={{
                              color: "#fff",
                              fontWeight: 500,
                              fontSize: 16,
                            }}
                          >
                            {logger.user.name}
                          </Typography>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 5,
                            margin: 5,
                            marginTop: 30,
                            marginBottom: 20,
                            width: "100%",
                            border: 0,
                            padding: 5,
                            borderRadius: 8,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "flex-start",
                              alignItems: "center",
                              gap: 5,
                            }}
                            onClick={() => setCurrentTab("My Applications")}
                          >
                            <LibraryBooks
                              style={{ color: "#fff", fontSize: 25 }}
                            />
                            <Typography
                              variant="subtitle2"
                              style={{ color: "#fff", fontWeight: 500 }}
                            >
                              My Applications
                            </Typography>
                          </div>

                          <ChevronRight
                            style={{ color: "#fff", fontSize: 25 }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <a
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 10,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setLogType("signup");
                        setOpenLoginDialog((prev) => {
                          return !prev;
                          handleToggle();
                        });
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{ color: "#fff", fontWeight: 600 }}
                      >
                        Sign Up
                      </Typography>{" "}
                      <ArrowForward style={{ color: "white" }} />
                    </a>
                    <a
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 10,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setLogType("login");
                        setOpenLoginDialog((prev) => {
                          return !prev;
                        });
                        handleToggle();
                      }}
                    >
                      <Login style={{ color: "#fff" }} />
                      <Typography
                        variant="subtitle2"
                        style={{ color: "#fff", fontWeight: 600 }}
                      >
                        Log in
                      </Typography>
                    </a>
                  </div>
                )}
              </div>
              <div
                style={{
                  width: "100%",

                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderTop: "1px solid #ccc",
                  paddingTop: 10,
                }}
              >
                {logger.isLogged ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      cursor: "pointer",
                      gap: 5,
                    }}
                    onClick={() => {
                      handleLogout();
                      handleToggle();
                    }}
                  >
                    <Logout
                      style={{ fontSize: 20, marginLeft: 20, color: "#fff" }}
                    />
                    <Typography
                      variant="subtitle2"
                      style={{ color: "#fff", fontWeight: 600 }}
                    >
                      Logout
                    </Typography>
                  </div>
                ) : (
                  <div></div>
                )}
                <div>
                  <Close
                    style={{ fontSize: 20, cursor: "pointer" }}
                    onClick={handleToggle}
                  />
                </div>
              </div>
            </div>
          </div>
        </ul>
      </nav>
    </>
  );
};

export default Navbar;
